export default __webpack_public_path__ + "static/media/lootboxlogo.318d3750.PNG";